<template>
  <b-modal :id="bModal.id" :title="bModal.title" centered hide-footer>
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">{{ card.title }}</h4>
          <b-alert
            v-if="alert && alert.alertMsg"
            show
            dismissible
            :variant="alert.alertVariant"
            >{{ alert.alertMsg }}</b-alert
          >
          <p class="card-title-desc">
            {{ card.description }}
          </p>
          <form class="needs-validation" @submit.prevent="formSubmit()">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="validationCustom01">Όνομα Αργίας</label>
                  <input
                    id="validationCustom01"
                    type="text"
                    class="form-control"
                    placeholder="Ονομα Αργίας"
                    required
                    :value="name"
                    ref="holiday_name"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="validationCustom02">Ημερομηνία</label>
                  <input
                    id="validationCustom02"
                    type="date"
                    class="form-control"
                    placeholder="Ημερομηνία Αργιας"
                    required
                    :value="dateToLocale"
                    ref="date"
                  />
                </div>
              </div>
            </div>
            <button class="btn btn-primary" type="submit">
              Ολοκλήρωση
            </button>
          </form>
        </div>
      </div>
      <!-- end card -->
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "FormModal",
  props: {
    bModal: {
      id: String,
      title: String,
    },
    card: {
      title: String,
      description: String,
    },
    name: {
      required: false,
      type: String,
    },
    dateValue: {
      required: false,
      type: String,
    },
    action: {
      required: true,
      type: String,
    },
    errors: {
      type: [Object, Array],
      default: () => null,
    },
    alert: {
      alertVariant: String,
      alertMsg: String,
    },
  },
  data() {
    return {
      is_success: false,
    };
  },

  computed: {
    dateToLocale() {
      if (this.$props.dateValue) {
        return this.$props.dateValue
          .split("/")
          .reverse()
          .join("-");
      } else {
        return 0;
      }
    },
  },

  methods: {
    formSubmit() {
      this.holidayName = this.$refs["holiday_name"].value;
      this.holidayDate = this.$refs["date"].value;

      this.$emit(
        "formData",
        this.holidayDate,
        this.holidayName,
        this.$props.action,
        this.$props.name
      );
    },
  },
};
</script>
